import { Card, Checkbox, DatePicker, Form, Input, Select } from "antd";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import {
  updateDoc,
  doc,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db, auth } from "../../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { salutation } from "../../../../utils/tenants";

import dayjs from "dayjs";

import FormAction from "../../../../components/common/FormAction";

function Tanent({ data }) {
  const [checked, setChecked] = useState(false);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));
      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const onCancel = () => {
    setChecked(false);
  };

  const handleFormSubmit = (values) => {
    console.log(values);
    Object.keys(values).forEach((field) => {
      if (values[field] === undefined) {
        values[field] = "";
      }
    });
    const profileInfo = {
      "profileInfo.salutation": values.salutation,
      "profileInfo.firstName": values.firstName,
      "profileInfo.middleName": values.middleName,
      "profileInfo.lastName": values.lastName,
      "profileInfo.dateOfBirth": values.dateOfBirth
        ? values.dateOfBirth.format("YYYY-MM-DD")
        : data?.profileInfo?.dateOfBirth,
      "profileInfo.companyName": values.companyName,
      "profileInfo.companyNameAsDisplay": values.companyNameAsDisplay,
    };
    try {
      const tenantRef = doc(db, "companies", companyName, "tenants", data?.id);
      updateDoc(tenantRef, profileInfo);
      toast.success("Tenant profile info updated successfully");
      setChecked(false);
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    toast.error("There are problems with one or more required fields");
    console.log("Failed:", errorInfo);
  };

  const initialValues = {
    salutation: data?.profileInfo?.salutation,
    firstName: data?.profileInfo?.firstName,
    middleName: data?.profileInfo?.middleName,
    lastName: data?.profileInfo?.lastName,
    dateOfBirth: data?.profileInfo?.dateOfBirth
      ? dayjs(data?.profileInfo?.dateOfBirth, 'YYYY-MM-DD')
      : null,
    companyName: data?.profileInfo?.companyName,
    companyNameAsDisplay: data?.profileInfo?.companyNameAsDisplay,
  };

  return (
    <Card
      title={data?.profileInfo?.firstName + " " + data?.profileInfo?.lastName}
      extra={
        !checked ? (
          <span className="onclick-text" onClick={() => setChecked(true)}>
            Edit
          </span>
        ) : null
      }
    >
      {checked ? (
        <Form
          colon={false}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 11 }}
          labelWrap={{ span: 8 }}
          initialValues={initialValues}
          onFinish={handleFormSubmit}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item label="Salutation" name="salutation">
            <Select options={salutation} placeholder="Select..." />
          </Form.Item>
          <Form.Item
            label="First Name"
            name="firstName"
            required
            rules={[{ required: true, message: "Please enter first name" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item label="Middle Initial" name="middleName">
            <Input />
          </Form.Item>
          <Form.Item
            label="Last Name"
            name="lastName"
            required
            rules={[{ required: true, message: "Please enter last name" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item label="Date Of Birth" name="dateOfBirth">
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item label="Company Name" name="companyName">
            <Input />
          </Form.Item>
          <Form.Item
            label=" "
            name="companyNameAsDisplay"
            valuePropName="checked"
          >
            <Checkbox
              checked={initialValues.companyNameAsDisplay ? true : false}
            >
              Use Company Name as display name
            </Checkbox>
          </Form.Item>
          <FormAction cancel={onCancel} submit="submit" />
        </Form>
      ) : (
        <span className="silver-text">
          Date of Birth: {data?.profileInfo?.dateOfBirth}
        </span>
      )}
    </Card>
  );
}

export default Tanent;
